import {Component, EventEmitter, Input, OnChanges, OnInit, Output, ViewChild, ViewEncapsulation} from '@angular/core';
import {SearchCriteria} from '../../../../../model/search-criteria';
import {User} from '../../../../../model/user';
import {AuthenticationService} from '../../../../../services/apiServices/security/authentication.service';
import {TranslateService} from '@ngx-translate/core';
import {Calendar} from "primeng/calendar";
import {TemplateConfig, TemplatesConfig} from "../../../../../model/templatesConfig";
import {SelectItemGroup} from "primeng/api";
import {CreateDepositService} from "../../../../../services/apiServices/business/create-deposit.service";
import {CommonService} from "../../../../../services/apiServices/business/common.service";

/**
 * Component that handle all the criterias to request the back inside search
 */
@Component({
  selector: 'app-search-filter',
  templateUrl: './filter.component.html',
  styleUrls: ['./filter.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class FilterComponent implements OnInit, OnChanges {
  /**
   * the list of operators that are available
   */
  public Operators: string[] = ['=', '<', '>', '!=', '<=', '>='];

  /**
   * the selected Operator (binding by a select)
   */
  public selectedOperator: string;

  /**
   * the options using Operators
   */
  public options: any[];
  public motifOptions: any[];

  public emailTemplates: any[];
  public emailTemplateConfig: TemplateConfig;
  public selectedEmailTemplateValue: string;
  /**
   * the criteria that will be modified
   */
  @Input() public criteria: SearchCriteria;

  /**
   * the up to date status of value Field
   */
  @Input('valueFieldIsNotUpToDate') public valueFieldIsNotUpToDate: boolean;

  /**
   * the fieldValue typed by the user
   */
  @Input('fieldValue') public fieldValue;

  /**
   * event fired when the criteria is updated
   */
  @Output() public criteriaChange: EventEmitter<SearchCriteria>;
  currentUser: User;

  public selectedDates: Date[] = [];
  public yearRange = [new Date('2012-01-01'), new Date()];
  public selectedMotif: string;
  public inputTextValue: string;

  /**
   * default constructor that instantiate objects and assign default choice for select
   */
  constructor(private commonService: CommonService, private authService: AuthenticationService, private translate: TranslateService, private createDepositService: CreateDepositService) {
    this.selectedOperator = this.Operators[0];
    this.criteriaChange = new EventEmitter<SearchCriteria>();
    this.emailTemplates = [];
  }

  @ViewChild('customPeriodCal', {static: false}) customPeriodCal: Calendar;

  /**
   * build Options for select
   */
  public ngOnInit(): void {
    this.currentUser = this.authService.getCurrentUser();
    this.options = [];
    for (const symbol of this.Operators) {
      this.options.push({label: symbol, value: symbol});
    }
    this.motifOptions = [];
    this.motifOptions.push({label: this.translate.instant('FOLDS.LIST_COMPONENT.MOTIFS_ALL'), value: ''});
    const listePNDmotif = [0,1,2,10,11]
    listePNDmotif.forEach(motif =>{
      this.motifOptions.push({label: this.translate.instant('FOLDS.LIST_COMPONENT.MOTIFS_' + motif), value: motif});
    });
    if (this.criteria.sNameId === "Modèle du mail") {
      this.loadTemplates();
    }
  }

  /**
   * triggered only on Input change (binding)
   */
  public ngOnChanges(): void {
    /*if (!this.fieldValue) {
      this.fieldValue = this.criteria.sCriteriaTrackingValue;
    }*/
    this.updateCriteria();
  }

  /**
   * update SearchCriteria and emit the changes
   */
  public updateCriteria(): void {
    this.criteria.sComparatorTrackingValue = this.selectedOperator;
    let newValue = this.fieldValue;
    if (newValue === '') {
      newValue = null;
    }
    setTimeout(() => {
      this.updateValue();
      this.criteriaChange.emit(this.criteria);
    }, 300);
  }

  /**
   * update SearchCriteria with email template and emit the changes
   */
  public updateCriteriaForEmailTemplate(): void {
    this.criteria.sComparatorTrackingValue = this.selectedOperator;
    if(this.selectedEmailTemplateValue != ""){
      this.criteria.sCriteriaTrackingValue = this.selectedEmailTemplateValue;
    }
    else{
      this.criteria.sCriteriaTrackingValue = null;
    }
    setTimeout(() => {
      this.updateValue();
      this.criteriaChange.emit(this.criteria);
    }, 300);
  }

  /**
   * if the label need to be translate (is that a persoField or not?)
   * @return {boolean} - the result
   */
  labelNeedTranslation(): boolean {
    return !(this.criteria.sNameId && this.criteria.sNameId.includes('persoField'));
  }

  public showFilter(): boolean {
    return !(SearchCriteria.criteriaIsERLId(this.criteria) && !this.currentUser.permissions.webTabLre.available);
  }

  setMotifValue(event) {
    this.selectedMotif = event.value;
    this.criteria.sCriteriaTrackingValue = this.selectedMotif;
  }

  public customPeriodEntryIsNotValid(): boolean {
    if (this.selectedDates && this.selectedDates.length > 0) {
      return true;
    } else {
      return false;
    }
  }

  public formatTimeStamp(date: Date, start: boolean): string {
    const myDate = new Date(date);
    const year = myDate.getFullYear();
    const month = myDate.getMonth() + 1;
    const day = myDate.getDate();
    return year + '-' + (month < 10 ? '0' : '') + month + '-' + (day < 10 ? '0' : '') + day
      + (start ? ' 00:00:00.000' : ' 23:59:59.999');
  }

  public updateValue(): void {
    if (this.criteria.sTypeData === 'date') {
      if (this.selectedDates[0]) {
        this.criteria.sCriteriaTrackingValue = this.formatTimeStamp(this.selectedDates[0], true);
        if (!this.selectedDates[1]) {
          this.criteria.sCriteriaTrackingValue += '^' + this.formatTimeStamp(this.selectedDates[0], false);
        }
      } else {
        this.criteria.sCriteriaTrackingValue = '';
      }
      if (this.selectedDates[1]) {
        this.criteria.sCriteriaTrackingValue += '^' + this.formatTimeStamp(this.selectedDates[1], false);
      }
    } else {
      if (this.criteria.sNameId === 'motifPND') {
        this.criteria.sCriteriaTrackingValue = this.selectedMotif;
      }
    }
  }

  clearCriteria() {
    this.selectedDates = [];
    this.updateCriteria();
  }

  loadTemplates(): void {
    this.createDepositService.getExpressDepositTemplates().subscribe(response => {
      this.emailTemplates = [];
      if (response.groups) {
        const templatesConfig = new TemplatesConfig(response);
        this.emailTemplateConfig = templatesConfig.getTemplateConfig();
        for (const g of this.emailTemplateConfig.groups) {
          const entry: SelectItemGroup = {
            items: [],
            label: g.label,
            value: g.value
          };
          if (g.templates) {
            for (const p of g.templates) {
              entry.items.push({ label: p.label, value: p.value });
            }
          }
          this.emailTemplates.push(entry);
        }
      } else if (response.customerId !== null && response.customerId !== undefined) {
        return;
      } else {
        this.commonService.addToast({
          life: 5000,
          severity: 'error',
          summary: this.translate.instant('UPLOAD_COMPONENT.MISSING_TEMPLATES_TITLE'),
          detail: this.translate.instant('UPLOAD_COMPONENT.MISSING_TEMPLATES_MSG')
        });
      }
    });
  }
}
